// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: gZEhwnQAfx2q6zBpBNhhDQ
// Component: 6rSjFDYDzjHH
import * as React from "react";
import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  hasVariant,
  useDollarState
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import "@plasmicapp/react-web/lib/plasmic.css";
import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import projectcss from "./plasmic_collect_wise_draft.module.css"; // plasmic-import: gZEhwnQAfx2q6zBpBNhhDQ/projectcss
import sty from "./PlasmicAdvancedOptionsComponent.module.css"; // plasmic-import: 6rSjFDYDzjHH/css
import ChevronUpSvgIcon from "./icons/PlasmicIcon__ChevronUpSvg"; // plasmic-import: NOXSpKy5wnrC/icon
import ChevronDownSvgIcon from "./icons/PlasmicIcon__ChevronDownSvg"; // plasmic-import: B3NfmvoQPNM4/icon

createPlasmicElementProxy;

export const PlasmicAdvancedOptionsComponent__VariantProps = new Array(
  "opened"
);

export const PlasmicAdvancedOptionsComponent__ArgProps = new Array();

const $$ = {};

function PlasmicAdvancedOptionsComponent__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const stateSpecs = React.useMemo(
    () => [
      {
        path: "opened",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.opened
      }
    ],

    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });
  return (
    <button
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.button,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        plasmic_antd_5_hostless_css.plasmic_tokens,
        sty.root,
        { [sty.rootopened]: hasVariant($state, "opened", "opened") }
      )}
    >
      <div
        data-plasmic-name={"title20"}
        data-plasmic-override={overrides.title20}
        className={classNames(
          projectcss.all,
          projectcss.__wab_text,
          sty.title20,
          { [sty.title20opened]: hasVariant($state, "opened", "opened") }
        )}
      >
        {"Advanced Options"}
      </div>
      {(hasVariant($state, "opened", "opened") ? true : false) ? (
        <ChevronUpSvgIcon
          data-plasmic-name={"dropdownIcon3"}
          data-plasmic-override={overrides.dropdownIcon3}
          className={classNames(projectcss.all, sty.dropdownIcon3, {
            [sty.dropdownIcon3opened]: hasVariant($state, "opened", "opened")
          })}
          role={"img"}
        />
      ) : null}
      <ChevronDownSvgIcon
        data-plasmic-name={"dropdownIcon"}
        data-plasmic-override={overrides.dropdownIcon}
        className={classNames(projectcss.all, sty.dropdownIcon, {
          [sty.dropdownIconopened]: hasVariant($state, "opened", "opened")
        })}
        role={"img"}
      />

      {false ? (
        <ChevronUpSvgIcon
          data-plasmic-name={"dropdownIcon2"}
          data-plasmic-override={overrides.dropdownIcon2}
          className={classNames(projectcss.all, sty.dropdownIcon2)}
          role={"img"}
        />
      ) : null}
    </button>
  );
}

const PlasmicDescendants = {
  root: ["root", "title20", "dropdownIcon3", "dropdownIcon", "dropdownIcon2"],
  title20: ["title20"],
  dropdownIcon3: ["dropdownIcon3"],
  dropdownIcon: ["dropdownIcon"],
  dropdownIcon2: ["dropdownIcon2"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicAdvancedOptionsComponent__ArgProps,
          internalVariantPropNames:
            PlasmicAdvancedOptionsComponent__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicAdvancedOptionsComponent__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicAdvancedOptionsComponent";
  } else {
    func.displayName = `PlasmicAdvancedOptionsComponent.${nodeName}`;
  }
  return func;
}

export const PlasmicAdvancedOptionsComponent = Object.assign(
  // Top-level PlasmicAdvancedOptionsComponent renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    title20: makeNodeComponent("title20"),
    dropdownIcon3: makeNodeComponent("dropdownIcon3"),
    dropdownIcon: makeNodeComponent("dropdownIcon"),
    dropdownIcon2: makeNodeComponent("dropdownIcon2"),
    // Metadata about props expected for PlasmicAdvancedOptionsComponent
    internalVariantProps: PlasmicAdvancedOptionsComponent__VariantProps,
    internalArgProps: PlasmicAdvancedOptionsComponent__ArgProps
  }
);

export default PlasmicAdvancedOptionsComponent;
/* prettier-ignore-end */
